module.exports = __webpack_public_path__ + "static/img/case-gl-page-bg-05.b9d396c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/gl/case-gl-page-bg-05.png
// module id = jQSW
// module chunks = 1